import base64js from 'base64-js';

export function Base64Encode(str, encoding = 'utf-8') {
    var bytes = new TextEncoder(encoding).encode(str);        
    return base64js.fromByteArray(bytes);
}

export function Base64Decode(str, encoding = 'utf-8') {
    var bytes = base64js.toByteArray(str);
    return new TextDecoder(encoding).decode(bytes);
}